import { ContragentShow } from 'src/Pages/Contragents/Components/ContragentShow';
import { ContragentsList } from 'src/Pages/Contragents/Components/ContragentsList';

export const contragents = {
  list: ContragentsList,
  show: ContragentShow,
};
